import { useFormContext } from "react-hook-form";
import { CustomerSearchFilters, YES_NO_OPTIONS_BOOL } from "../../../types";
import CBSearchBooleanAutocompleteController from "../controller/CBSearchBooleanAutocompleteController";

const CBDigitalIdentitySearchFilter = () => {

    const formContext = useFormContext<CustomerSearchFilters>();
    
    return (
        <CBSearchBooleanAutocompleteController 
            idField="digitalIdentity"
            formName="digitalIdentity"
            label="idpUid"
            translateLabel="yesNoOptions"
            options={YES_NO_OPTIONS_BOOL}
            onChange={(value) => formContext.setValue("digitalIdentity", value ? value.value : null)}
        />
    )

}

export default CBDigitalIdentitySearchFilter;